/**
 * Узкий экран — телефон.
 *
 * Вынесено в отдельный файл, потому что от этой проверки зависит НЕ вёрстка,
 * а способ отдать файл: на телефоне ссылка «открыть в новой вкладке» не
 * работает. Установленное приложение новых вкладок не открывает вовсе — оно
 * передаёт адрес системному браузеру, а тот про вход в программу ничего не
 * знает и показывает «Требуется вход в систему» вместо документа.
 *
 * Порог тот же, что у остальной вёрстки: 767 пикселей.
 */
export function isNarrow(): boolean {
  try {
    return window.matchMedia('(max-width: 767px)').matches;
  } catch {
    // Проверка недоступна (старый браузер, отрисовка на сервере) — считаем
    // экран широким: ссылка в новой вкладке хуже всего лишь тем, что откроет
    // лишнюю вкладку, а скачивание там, где его не ждут, пугает сильнее.
    return false;
  }
}

/**
 * Подсказка поля поиска.
 *
 * На широком экране она перечисляет, что именно ищется («врач, пациент,
 * № счёта»): по номеру счёта искать умеет не всякий журнал, и без подсказки
 * об этом не догадаться. На телефоне поле вдвое уже, перечисление в него не
 * помещается и обрывается на полуслове — там остаётся одно слово «Поиск».
 */
export function подсказкаПоиска(полная: string): string {
  return isNarrow() ? 'Поиск…' : полная;
}

/**
 * Программа открыта как УСТАНОВЛЕННОЕ ПРИЛОЖЕНИЕ, а не вкладкой браузера.
 *
 * Отдельно от ширины экрана, и это важно: ширина отвечает на вопрос «как
 * рисовать», а этот признак — на вопрос «куда уйдёт ссылка». В установленном
 * приложении любая ссылка «в новую вкладку» уходит наружу, системному
 * браузеру, — и неважно, какой там экран. Браузер про вход в программу не
 * знает и вместо документа показывает «Требуется вход в систему».
 */
function isStandalone(): boolean {
  try {
    if (window.matchMedia('(display-mode: standalone)').matches) return true;
    if (window.matchMedia('(display-mode: fullscreen)').matches) return true;
    if (window.matchMedia('(display-mode: minimal-ui)').matches) return true;
    // Признак установленного приложения в Safari на iPhone: своего
    // `display-mode` он долго не поддерживал.
    return (window.navigator as { standalone?: boolean }).standalone === true;
  } catch {
    return false;
  }
}

/**
 * Документ нужно ЗАБРАТЬ и отдать загрузкой, а не открывать ссылкой.
 *
 * Два случая, и оба ведут к одному: телефон (ссылка откроется в браузере,
 * который не умеет показывать PDF внутри себя и теряет имя файла) и
 * установленное приложение при любом экране (ссылка уходит наружу вместе
 * с потерей входа в программу).
 */
export function prefersDownload(): boolean {
  return isNarrow() || isStandalone();
}
